import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { PushService } from './push/push.service';
import { WebPushService } from './push/web-push.service';
import { NativePushService } from './push/native-push.service';
import { KeyboardService } from './keyboard/keyboard.service';
import { WebKeyboardService } from './keyboard/web-keyboard.service';
import { NativeKeyboardService } from './keyboard/native-keyboard.service';
import { AppLifecycleService } from './app-lifecycle/app-lifecycle.service';
import { WebAppLifecycleService } from './app-lifecycle/web-app-lifecycle.service';
import { NativeAppLifecycleService } from './app-lifecycle/native-app-lifecycle.service';
import { OtaUpdateService } from './ota-update/ota-update.service';
import { WebOtaUpdateService } from './ota-update/web-ota-update.service';
import { NativeOtaUpdateService } from './ota-update/native-ota-update.service';

export function providePlatform(): EnvironmentProviders {
  const isNative = Capacitor.isNativePlatform();
  return makeEnvironmentProviders([
    {
      provide: PushService,
      useClass: isNative ? NativePushService : WebPushService,
    },
    {
      provide: KeyboardService,
      useClass: isNative ? NativeKeyboardService : WebKeyboardService,
    },
    {
      provide: AppLifecycleService,
      useClass: isNative ? NativeAppLifecycleService : WebAppLifecycleService,
    },
    {
      provide: OtaUpdateService,
      useClass: isNative ? NativeOtaUpdateService : WebOtaUpdateService,
    },
    provideEnvironmentInitializer(() => {
      inject(KeyboardService).init();
      inject(AppLifecycleService).init();
      inject(OtaUpdateService).init();
    }),
  ]);
}
